import React, { useEffect, useRef } from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

// Styles
import './LeoPopup.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FocusTrap } from "focus-trap-react";

function LeoPopupBody(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		headline: {
			fontSize: context.themeManager.value('popup-headline', 'fontSize', 'font-size-300'),
			color: context.themeManager.value('popup-headline', 'color', 'fg-color-text-highlight'),
		},
		closeIcon: {
			fontSize: context.themeManager.value('popup-close-icon', 'fontSize', 'font-size-600'),
			color: context.themeManager.value('popup-close-icon',
				'color', 'fg-color-icon-highlight'),
			'&:focusVisible': {
				outline: 'auto',
			}
		},
		popup: {
			color: context.themeManager.value('popup-body', 'color', 'fg-color-text'),
			backgroundColor: context.themeManager.valueOrDefault('popup-body', 'bgColor', null, '#fff'),
			border: context.themeManager.valueOrDefault('popup-body', 'border', null, 'none'),
		},
		backdrop: {
			'--leo-backdropColor': context.themeManager.valueOrDefault('popup-body', 'backdrop', null, 'rgba(0,0,0,0.5)'),
		}
	};

	const buttonRef = useRef(null);
	useEffect(() => {
		setTimeout(() => buttonRef?.current?.focus(), 0);
	}, []);
	return (
		<div className="leo-popup__backdrop" style={style.backdrop}>
			<FocusTrap>
				<div className="leo-popup__container" style={style.popup} role="dialog" aria-modal="true"
					aria-labelledby="popupTitle" {...(props.children_ ? {'aria-describedby': 'popupText'} : {})} aria-hidden="false">
					<header className="leo-popup__header">
						<h2 className="leo-popup__headline" id="popupTitle" style={style.headline}>
							{props.headline}
						</h2>
						{props.onClose
							&& (
								<button id="close-button" ref={buttonRef} className="leo__button-sample"
										onClick={props.onClose} aria-selected="true" aria-labelledby="close">
									<FontAwesomeIcon
										id="close"
										aria-label="Fenster schließen"
										aria-hidden="false"
										title="Fenster schließen"
										icon="times-circle"
										style={style.closeIcon}
									/>
								</button>

							)}
					</header>
					{props.children_
						&& (
							<div
								id="popupText"
								className="leo-popup__content"
								tabIndex="0"
								dangerouslySetInnerHTML={{__html: props.children_}}
							/>
						)}
					{props.childComponent
						&& (
							<div className="leo-popup__child-container">
								{props.childComponent}
							</div>
						)}
				</div>
			</FocusTrap>
		</div>
	);
}

export default radium(LeoPopupBody);
